<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container">
      <div class="row">
        <div class="col-sm-12" style="margin:20px; background:white; border-radius:10px;padding:10px">
          <h1> Announcements</h1>
          <div style="padding-bottom:20px;" v-for="(a,idx) in store.state.announcements" :key="idx">
            <h4>{{a.title}}</h4>
            <small>{{date(a.ts)}}</small>
            <p>{{a.description}}</p>
            <hr>
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import Store from './AnnouncementsStore'
import API from '@/API/API'
import DashboardFooter from './nav/Footer'
import Utils from '../Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
import moment from 'moment'
export default {
  name: 'Home',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      store: Store,
      api: API,
      nav: Navigator,
      accountUtils: AccountSessionUtils
    }
  },
  mounted () {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        this.store.getAnnouncements()
      },
      () => {}
    );
  },
  methods: {
    date(ts) {
      return moment(ts).format("MMM DD YYYY")
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Announcements.vue